module.exports = __webpack_public_path__ + "media/images/xing-b65d78f87c8abc49dcc2be93796434f4.png";